import { Button, ButtonProps } from '@mui/material';
import { FC } from 'react';
import '../Button.scss';

const SecondaryButton: FC<ButtonProps & React.HTMLProps<HTMLButtonElement>> = ({
  children,
  ...props
}) => {
  return (
    <Button {...props} variant="contained" color="secondary">
      {children}
    </Button>
  );
};

export default SecondaryButton;
